import { render, staticRenderFns } from "./Posture_perfect.vue?vue&type=template&id=5f217114"
import script from "./Posture_perfect.vue?vue&type=script&lang=js"
export * from "./Posture_perfect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports